import * as React from 'react';
export const TreeViewItemDepthContext = /*#__PURE__*/React.createContext(() => -1);
if (process.env.NODE_ENV !== 'production') {
  TreeViewItemDepthContext.displayName = 'TreeViewItemDepthContext';
}